<head>
  <meta
    name="description"
    content="Leon ist ein Fullstack Webentwickler aus dem Kreis Neuburg-Schrobenhausen. Aktuell arbeitet er als Microsoft 365 Entwickler bei Arvato Systems. Leon verwendet Technologien wie 
    Angular, ASP.NET, Wordpress und Microsoft Power Platform."
  />
</head>
<div class="bg" [animate.enter]="['entering']">
  <div class="home-container">
    <div class="headline">
      <div class="text_container">
        <h1 class="header">All eyes on aesthetic and cats</h1>
      </div>
    </div>
    <div class="content">
      <app-content-card>
        <app-data-card></app-data-card>
        <app-discord></app-discord>
        <app-about></app-about>
        <app-portfolio></app-portfolio>
        <h2>skills.</h2>
        <app-chip [chips]="chips"></app-chip>
        <h2 style="padding-top: 20px">hobbies.</h2>
        <app-chip [chips]="hobbies"></app-chip>
        <app-links
          GitHub="{{ GitHub }}"
          Instagram="{{ Instagram }}"
          LinkedIn="{{ LinkedIn }}"
          Mail="{{ Mail }}"
          Stackoverflow="{{ Stackoverflow }}"
        ></app-links>
        <app-footer></app-footer>
      </app-content-card>
    </div>
  </div>
</div>
